import React, { forwardRef } from 'react';
import './ScrollSentinel.scss';

interface ScrollSentinelProps {
  className?: string;
}

/**
 * Componente sentinel para infinite scroll
 * Debe usarse con el hook useInfiniteScroll
 */
export const ScrollSentinel = forwardRef<HTMLDivElement, ScrollSentinelProps>(
  ({ className = '' }, ref) => {
    return (
      <div 
        ref={ref} 
        className={`scroll-sentinel ${className}`.trim()}
        aria-hidden="true"
      />
    );
  }
);

ScrollSentinel.displayName = 'ScrollSentinel';

